import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// const catchDate = 7; //缓存天数
//state
const state = {
  env: null, // 区分端的api，入口手动配置，必须
  actName: null, // 活动名称
  businessLine: null, // 业务线
  uuid: '', //活动uuid
  version: null, // 来源版本号 5020
  ref: null, // 渠道
  cityId: null, // 城市id
  ua: null, // 页面环境， wxa微信小程序 、wxashadow微信小程序马甲包
  fromId: 0, // 分享取到的记录id，用于统计
  appClient: null, // 所以运行环境 app 小程序等
  accessToken: null, // 活动使用的token
  openAuth: null, // 个人外发所需要的token，如分享内容需要有自己的非敏感信息key值
  appToken: null, // 内部app传入token
  wxToken: null, // 微信登录时用的token
  dirverCode: null, // Fingerprint2浏览器32位指纹码
  accountType: null, // 账户体系
  hostInfo: null // host配置，为测试而生
};

// getters
const getters = {};

// mutations
const mutations = {
  set_env(state, payload) {
    state.env = payload;
  },
  set_actName(state, payload) {
    state.actName = payload;
  },
  set_businessLine(state, payload) {
    state.businessLine = payload;
  },
  set_version(state, payload) {
    state.version = payload;
  },
  set_uuid(state, payload) {
    state.uuid = payload;
  },
  set_ref(state, payload) {
    state.ref = payload;
  },
  set_cityId(state, payload) {
    state.cityId = payload;
  },
  set_ua(state, payload) {
    state.ua = payload;
  },
  set_appClient(state, payload) {
    state.appClient = payload;
  },
  set_accessToken(state, payload) {
    state.accessToken = payload;
  },
  set_openAuth(state, payload) {
    state.openAuth = payload;
  },
  set_appToken(state, payload) {
    state.appToken = payload;
  },
  set_wxToken(state, payload) {
    state.wxToken = payload;
  },
  set_dirverCode(state, payload) {
    state.dirverCode = payload;
  },
  set_fromId(state, payload) {
    state.fromId = payload;
  },
  set_accountType(state, payload) {
    state.accountType = payload;
  },
  set_hostInfo(state, payload) {
    state.hostInfo = payload;
  }
};

// actions
const actions = {
  // accessToken ({commit}) {
  //   fetch.get('/index.php?_m=common_api&_a=get_weixin_jssdk', {
  //     params: {
  //       url: location.href
  //     }
  //   }).then( (res) => {
  //     console.log("getSDKInfo22", res);
  //   });
  //   commit('TOKEN');
  // }
};

const global = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    global
  },
  strict: debug,
  plugins: [
    createPersistedState({
      //持久化vuex,页面刷新时数据不会丢失,存储在sessionStorage
      storage: {
        getItem: key => {
          try {
            let obj = JSON.parse(sessionStorage.getItem(key));
            delete obj.app;
            return JSON.stringify(obj);
          } catch {
            return sessionStorage.getItem(key);
          }
        },
        setItem: (key, value) => {
          try {
            let obj = JSON.parse(value);
            delete obj.app;
            sessionStorage.setItem(key, JSON.stringify(obj), { expires: 7 });
          } catch (e) {
            console.error(e);
            sessionStorage.setItem(key, value, { expires: 7 });
          }
        },
        removeItem: key => sessionStorage.removeItem(key)
      }
    })
  ]
});

export default store;
